import { Slider, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface SeasonRangeSelectorControlProps {
    seasonRangeChanged: (event: Event, value: number | number[]) => void;
}

function SeasonRangeSelectorControl(props: SeasonRangeSelectorControlProps) {
    const currentYear = new Date().getUTCFullYear();
    const [value, setValue] = React.useState<number[]>([currentYear, currentYear]);
    const { t } = useTranslation("common");

    const handleChange = (event: Event, newValue: number | number[]) => {
        setValue(newValue as number[]);
        props.seasonRangeChanged(event, newValue);
    };
    return (
        <React.Fragment>
            <Typography id="range-slider" gutterBottom>
                {t("seasonSelector.selectSeasons")}
            </Typography>
            <Slider
                value={value}
                onChange={handleChange}
                valueLabelDisplay="on"
                aria-labelledby="range-slider"
                step={1}
                marks
                min={2013}
                max={currentYear}
            />
        </React.Fragment>
    );
}
export default SeasonRangeSelectorControl;